<!-- <app-header></app-header>
<main>
<div *ngIf="isServer">
    <router-outlet></router-outlet>
</div>
<div *ngIf="isBrowser">
    <router-outlet></router-outlet>
</div>
</main>
<app-footer *ngIf="isContentLoaded"></app-footer>
 -->

<header>
  <app-header></app-header>
</header>

<section
  class="forum-announcement"
  *ngIf="showForumAnnouncement && isHomeRoute && !isForumsRoute"
  [ngClass]="{ 'forum-announcement--home': isHomeRoute }"
  aria-label="AskIITians forum call to action"
>
  <div class="forum-announcement__inner">
    <button
      type="button"
      class="forum-announcement__close"
      aria-label="Close forum announcement"
      (click)="dismissForumAnnouncement()"
    >
      ×
    </button>

    <span class="forum-announcement__pattern forum-announcement__pattern--top" aria-hidden="true"></span>
    <span class="forum-announcement__pattern forum-announcement__pattern--bottom" aria-hidden="true"></span>

    <div class="forum-announcement__copy">
      <div class="forum-announcement__headline">
        <span class="forum-announcement__badge">New</span>
      </div>

      <div class="forum-announcement__hero">
        <div class="forum-announcement__illustration" aria-hidden="true">
          <img src="assets/images/forum.png" alt="" loading="lazy">
        </div>

        <div class="forum-announcement__content">
          <h3>Need help<br>with a problem?</h3>
          <p>Ask IITian experts and get clear answers, fast.</p>
        </div>
      </div>

      <div class="forum-announcement__chips" aria-label="Forum benefits">
        <span class="forum-announcement__chip forum-announcement__chip--green">Free to Ask</span>
        <span class="forum-announcement__chip forum-announcement__chip--orange">Expert Answers</span>
        <span class="forum-announcement__chip forum-announcement__chip--blue">Clear Solutions</span>
      </div>

      <div class="forum-announcement__proof" aria-label="Trusted by 250000 plus students">
        <span class="forum-announcement__avatars" aria-hidden="true">
          <span class="forum-announcement__avatar forum-announcement__avatar--one">A</span>
          <span class="forum-announcement__avatar forum-announcement__avatar--two">R</span>
          <span class="forum-announcement__avatar forum-announcement__avatar--three">K</span>
        </span>
        <span class="forum-announcement__proof-text">Trusted by 250,000+ students</span>
        <span class="forum-announcement__proof-verified" aria-hidden="true"><i class="fa fa-check"></i></span>
      </div>
    </div>

    <div class="forum-announcement__footer">
      <a routerLink="/forums" class="forum-announcement__cta" aria-label="Post your question on the forum">
        <span>Ask a Question</span>
        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
      </a>
    </div>

  </div>
</section>

<main>
  <router-outlet *ngIf="isServer || isBrowser"></router-outlet>
</main>

<footer *ngIf="isContentLoaded && !isOnboardingRoute">
  <app-footer></app-footer>
</footer>
